import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_USERS_ANALYTICS_DETAILS, GET_USERS_ANALYTICS_DETAILS_ERROR, GET_USERS_ANALYTICS_DETAILS_SUCCESS } from '../../actions.js';

function* getUsersAnalyticsDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/user-analytics`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_USERS_ANALYTICS_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_USERS_ANALYTICS_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_USERS_ANALYTICS_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetUsersAnalyticsDetails() {
  yield takeEvery(GET_USERS_ANALYTICS_DETAILS, getUsersAnalyticsDetails);
}

function* getUsersAnalyticsDetailsSaga() {
  yield all([fork(watchGetUsersAnalyticsDetails)]);
}

export default getUsersAnalyticsDetailsSaga;
